export default "__VITE_ASSET__eogQwjgv__"